
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"60","height":"35","x":"10","y":"10","fill":"#308BE5","rx":"6"}}),_c('rect',{attrs:{"width":"60","height":"20","x":"10","y":"50","fill":"#71B7FD","rx":"6"}}),_c('rect',{attrs:{"width":"40","height":"15","x":"20","y":"20","fill":"#A8D1FA","rx":"6"}}),_c('path',{attrs:{"fill":"#023E92","d":"M51.685 37.066l-15.608-10.79s-3.294-1.993-4.335-.997c-1.387.498-1.734 3.985-1.734 3.985v18.428c-.174 4.317 2.601 4.98 2.601 4.98.867.167 1.56-.165 2.081-.497.694-.498 1.56-1.827 1.56-1.827l1.908-4.316 4.162 6.973c2.428 3.32 4.856 1.494 4.856 1.494.347-.166 2.775-1.162 1.56-4.649l-3.467-7.305 4.855.996s1.734.166 2.428 0 1.214-.664 1.734-1.328c.174-.166 1.214-2.656-2.601-5.147z"}})])
          )
        }
      }
    